<template>
  <div>
    <b-menu-list :label="$t('compCarbonDocsMenu.label-1')">
      <b-menu-item
        :active="
          buffer === 'ges-methodology' ||
          buffer === 'ges-calculating-methods' ||
          buffer === 'ges-update-emissions-factors' ||
          buffer === 'ges-emissions-factors' ||
          buffer === 'ges-ademe-diff'
        "
        :expanded="
          buffer === 'ges-methodology' ||
          buffer === 'ges-calculating-methods' ||
          buffer === 'ges-update-emissions-factors' ||
          buffer === 'ges-emissions-factors' ||
          buffer === 'ges-ademe-diff'
        "
        @click="activate('ges-methodology')"
      >
        <template slot="label" slot-scope="props">
          <b-icon icon="book"></b-icon>
          {{ $t('compCarbonDocsMenu.label-2') }}
          <b-icon
            class="is-pulled-right"
            :icon="props.expanded ? 'caret-down' : 'caret-up'"
          >
          </b-icon>
        </template>
        <b-menu-item
          :active="buffer === 'ges-methodology'"
          @click="activate('ges-methodology')"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="info"></b-icon>
                  {{ $t('compCarbonDocsMenu.label-3') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
        <b-menu-item
          @click="activate('ges-emissions-factors')"
          :active="buffer === 'ges-emissions-factors'"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="cloud"></b-icon>
                  {{ $t('compCarbonDocsMenu.label-4') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
        <b-menu-item
          @click="activate('ges-update-emissions-factors')"
          :active="buffer === 'ges-update-emissions-factors'"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="refresh"></b-icon>
                  {{ $t('compCarbonDocsMenu.label-5') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
        <b-menu-item
          @click="activate('ges-calculating-methods')"
          :active="buffer === 'ges-calculating-methods'"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="cog"></b-icon>
                  {{ $t('compCarbonDocsMenu.label-6') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
        <b-menu-item
          :active="buffer === 'ges-ademe-diff'"
          @click="activate('ges-ademe-diff')"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="chain-broken"></b-icon>
                  {{ $t('compCarbonDocsMenu.label-7') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
      </b-menu-item>
      <b-menu-item
        :active="buffer === 'ges-notes' || buffer === 'ges-manual'"
        :expanded="buffer === 'ges-notes' || buffer === 'ges-manual'"
        @click="activate('ges-notes')"
      >
        <template slot="label" slot-scope="props">
          <b-icon icon="life-ring"></b-icon>
          {{ $t('compCarbonDocsMenu.label-8') }}
          <b-icon
            class="is-pulled-right"
            :icon="props.expanded ? 'caret-down' : 'caret-up'"
          >
          </b-icon>
        </template>
        <b-menu-item
          :active="buffer === 'ges-notes'"
          @click="activate('ges-notes')"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="warning"></b-icon>
                  {{ $t('compCarbonDocsMenu.label-9') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
        <b-menu-item
          :active="buffer === 'ges-manual'"
          @click="activate('ges-manual')"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="book"></b-icon>
                  {{ $t('compCarbonDocsMenu.label-10') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
      </b-menu-item>
      <b-menu-item
        @click="activate('ges-data-protection')"
        :active="buffer === 'ges-data-protection'"
      >
        <template slot="label">
          <nav class="level">
            <div class="level-left">
              <div class="level-item">
                <b-icon icon="shield"></b-icon>
                {{ $t('compCarbonDocsMenu.label-13') }}
              </div>
            </div>
          </nav>
        </template>
      </b-menu-item>
      <!-- <b-menu-item
        :active="buffer === 'ges-team' || buffer === 'ges-thanks'"
        :expanded="buffer === 'ges-team' || buffer === 'ges-thanks'"
        @click="activate('ges-team')"
      >
        <template slot="label" slot-scope="props">
          <b-icon icon="users"></b-icon>
          {{ $t('compCarbonDocsMenu.label-14') }} <em>Ekocentral GES</em>
          <b-icon
            class="is-pulled-right"
            :icon="props.expanded ? 'caret-down' : 'caret-up'"
          >
          </b-icon>
        </template>
        <b-menu-item
          :active="buffer === 'ges-team'"
          @click="activate('ges-team')"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="keyboard-o"></b-icon>
                  {{ $t('compCarbonDocsMenu.label-15') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
        <b-menu-item
          :active="buffer === 'ges-thanks'"
          @click="activate('ges-thanks')"
        >
          <template slot="label">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <b-icon icon="thumbs-o-up"></b-icon>
                  {{ $t('compCarbonDocsMenu.label-16') }}
                </div>
              </div>
            </nav>
          </template>
        </b-menu-item>
      </b-menu-item> -->
    </b-menu-list>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      buffer: this.value
    }
  },
  watch: {
    value: function () {
      this.buffer = this.value
    }
  },
  methods: {
    activate: function (val) {
      this.buffer = val
      this.$emit('input', this.buffer)
    }
  }
}
</script>
